import { useState } from 'react';
import type { PosEntityOption } from '@/types/api';

interface MultiSelectPosEntityProps {
  label: string;
  options: PosEntityOption[];
  selectedIds: number[];
  onChange: (ids: number[]) => void;
  searchable?: boolean;
}

export function MultiSelectPosEntity({ label, options, selectedIds, onChange, searchable = false }: MultiSelectPosEntityProps) {
  const [search, setSearch] = useState('');

  const filtered = searchable && search
    ? options.filter(o => o.name.toLowerCase().includes(search.toLowerCase()))
    : options;

  const toggle = (posId: number) => {
    onChange(selectedIds.includes(posId)
      ? selectedIds.filter(id => id !== posId)
      : [...selectedIds, posId]);
  };

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      {searchable && (
        <input
          type="text"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="input w-full mb-2"
        />
      )}
      <div className="max-h-40 overflow-y-auto border rounded p-2 space-y-1">
        {filtered.length === 0 ? (
          <span className="text-sm text-gray-400">No options available</span>
        ) : filtered.map(option => (
          <label key={option.posId} className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={selectedIds.includes(option.posId)}
              onChange={() => toggle(option.posId)}
              className="rounded border-gray-300"
            />
            {option.name}
          </label>
        ))}
      </div>
      {selectedIds.length > 0 && (
        <div className="text-xs text-gray-500 mt-1">{selectedIds.length} selected</div>
      )}
    </div>
  );
}
